import {
  getApplicantMetrics,
  getRoleMetrics,
} from 'modules/Exp-Candidates/actions'
import driveSelector from 'modules/Exp-Candidates/selectors'
import ApplicantTrackingSystem from 'modules/Roles/ViewRole/ApplicantTrackingSystem'
import {
  getApplicantCandidateList,
  getAppliedCandidateListTrue,
  getCollegeBasedOnATS,
  getDegreeBasedOnATS,
  getDegreesBasedOnRoles,
  getLocationBasedOnATS,
  getRescheduleList,
  getRoleCityData,
  getRoleViewCard,
  getRoleViewChart,
  getSingleRoleData,
  getUniqueStudentInstitutesList,
} from 'modules/Roles/actions'
import rolesSelectors from 'modules/Roles/selectors'
import { connect } from 'react-redux'

const mapStateToProps = state => ({
  roleViewCardData: rolesSelectors.getRoleViewCard(state),
  roleViewChartData: rolesSelectors.getRoleViewChart(state),
  roleBasedDegreeList: rolesSelectors?.getDegreeRolesList(state),
  atsBasedDegreeList: rolesSelectors?.getDegreeATSList(state),
  atsBasedCollegeList: rolesSelectors?.getCollegeATSList(state),
  atsBasedLocationList: rolesSelectors?.getLocationATSList(state),
  singleRoleData: rolesSelectors?.getSingleRoleData(state),
  rolesMetrics: driveSelector.getRoleMetrics(state),
  appliedCandidatesListTrue:
    rolesSelectors?.getAppliedCandidatesListTrue(state),
  applicantMetrics: driveSelector.getApplicantMetrics(state),
  notifyReschedule: rolesSelectors.getRescheduleList(state),
  applicantCandidateList: rolesSelectors?.getApplicantCandidateList(state),
})

const mapDispatchToProps = {
  getRoleViewChart,
  getRoleViewCard,
  getDegreesBasedOnRoles,
  getDegreeBasedOnATS,
  getCollegeBasedOnATS,
  getLocationBasedOnATS,
  getSingleRoleData,
  getAppliedCandidateListTrue,
  getRoleCityData,
  getRoleMetrics,
  getApplicantMetrics,
  getApplicantCandidateList,
  getUniqueStudentInstitutesList,
  getRescheduleList,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ApplicantTrackingSystem)
